import {
  IFormLinkFieldConfigurationServer,
  IFormLinkFieldConfigurationClient,
} from "./interface";

export const transformFormFieldConfigClientToServer = (
  fieldConfigClient: IFormLinkFieldConfigurationClient
): IFormLinkFieldConfigurationServer => {
  const { formLinkId, isEditResponse, addResponseLabel, editResponseLabel } =
    fieldConfigClient;
  const fieldConfigServer = {
    formLinkId: formLinkId,
    isEditResponse: isEditResponse,
    addResponseLabel: addResponseLabel,
    editResponseLabel: editResponseLabel,
  };
  return fieldConfigServer;
};

export const transformFormLinkConfigServerToClient = (
  fieldConfigServer: IFormLinkFieldConfigurationClient
): IFormLinkFieldConfigurationServer => {
  const { formLinkId, isEditResponse, addResponseLabel, editResponseLabel } =
    fieldConfigServer;
  const fieldConfigClient = {
    formLinkId: formLinkId,
    isEditResponse: isEditResponse,
    addResponseLabel: addResponseLabel,
    editResponseLabel: editResponseLabel,
  };
  return fieldConfigClient;
};
